import { takeLatest, call, put, select } from "redux-saga/effects";
import {
  USER_USERNAME_CHANGE_REQUEST,
  userUsernameChanged,
  userUsernameChangeError,
} from "../../actions/users";
import { role as roleSelector, ADMIN } from "../../selectors/auth";
import scChangeUsername from "../../../../../backend/oncall/administration/users/change-username";
import partnerChangeUsername from "../../../../../backend/oncall/partners/users/change-username";

const changeUsername = function*(action) {
  try {
    const role = yield select(roleSelector);
    const changeUsername =
      role === ADMIN ? scChangeUsername : partnerChangeUsername;
    yield call(
      changeUsername,
      action.payload.username,
      action.payload.newUsername,
    );
    yield put(userUsernameChanged(action.payload.newUsername));
  } catch (error) {
    yield put(userUsernameChangeError(error.message));
  }
};

export default function*() {
  //noinspection JSCheckFunctionSignatures
  yield takeLatest(USER_USERNAME_CHANGE_REQUEST, changeUsername);
}



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/sagas/users/request-change-username.js